import axios from 'axios'; // 引入axios
import QS from 'qs'; //post 参数序列化

// 请求超时 请求头
// axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.delete['Content-Type'] = 'application/json';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = localStorage.getItem("token"); //token存储在浏览器
        token && (config.headers.Authorization = token);
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.status) {
            return Promise.reject(error.response);
        }
    }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(res => {
                if (res.data.code == 1001) {
                    resolve(res.data);
                } else if (res.data.code == -1000) {
                    this.$message.error(res.data.msg)
                    this.$router.replace({ path: '/login' })
                    localStorage.setItem("token", "")
                } else {
                    this.$message.error(res.data.msg)
                    resolve(res.data);
                }
            })
            .catch(err => {
                this.$message.error("系统异常,请稍后重试")
                reject(err.data)
            })
    });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getImg(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            }, { responseType: 'arraybuffer' })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                this.$message.error("系统异常,请稍后重试")
                reject(err.data)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                if (res.data.code == 1001) {
                    resolve(res.data);
                } else if (res.data.code == -1000) {
                    this.$message.error(res.data.msg)
                    this.$router.replace({ path: '/login' })
                    localStorage.setItem("token", "")
                } else {
                    this.$message.error(res.data.msg)
                    resolve(res.data);
                }
            })
            .catch(err => {
                this.$message.error("系统异常,请稍后重试")
                reject(err.data)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postArr(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                if (res.data.code == 1001) {
                    resolve(res.data);
                } else if (res.data.code == -1000) {
                    this.$message.error(res.data.msg)
                    this.$router.replace({ path: '/login' })
                    localStorage.setItem("token", "")
                } else {
                    this.$message.error(res.data.msg)
                    resolve(res.data);
                }
            })
            .catch(err => {
                this.$message.error("系统异常,请稍后重试")
                reject(err.data)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postArr1(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                this.$message.error("系统异常,请稍后重试")
                reject(err.data)
            })
    });
}
/**
 * 封装patch请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function patch(url, params) {
    return new Promise((resolve, reject) => {
        axios.patch(url, params)
            .then(res => {
                if (res.data.code == 1001) {
                    resolve(res.data);
                } else if (res.data.code == -1000) {
                    this.$message.error(res.data.msg)
                    this.$router.replace({ path: '/login' })
                    localStorage.setItem("token", "")
                } else {
                    this.$message.error(res.data.msg)
                    resolve(res.data);
                }
            })
            .catch(err => {
                this.$message.error("系统异常,请稍后重试")
                reject(err.data)
            })
    })
}

/**
 * put 请求
 * @param  url
 * @param  params
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, QS.stringify(params))
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}
/**
 * put 请求
 * @param  url
 * @param  params
 */
export function deleteArr(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, { data: params })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js